import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  VideoPageWrapper,
  VideoPageComponentWrapper,
  VideoPageComponentGrid,
  VideoGeneralContainer,
  VideoDescription,
  VideoPageBackTo,
} from "./VideoPage.styles";
import { BackIcon } from "../../assets/iconComponents/BackIcon";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { LANDING_PAGE_URL } from "../../utils/urlConstants";
import VideoLibraryCard from "./VideoLibraryCard";
import { videoList } from "./VideoData";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";
import { TrackAnalyticsEvent } from "../../services/Analytics";
import { AnalyticsEventNames } from "../../utils/analyticsEvents";

const VideoPage = (): React.ReactElement => {
  const { auth } = useAuthenticationHook();
  const { deviceType } = useDeviceHook();
  const history = useHistory();

  useEffect(() => {
    if (auth?.token) {
      TrackAnalyticsEvent(
        AnalyticsEventNames.VideoLibraryPageView,
        auth.token,
        auth.username,
      );
    }
  }, [auth]);

  return (
    <VideoPageWrapper>
      <VideoPageComponentWrapper deviceType={deviceType}>
        <VideoPageComponentGrid deviceType={deviceType}>
          <VideoPageBackTo onClick={() => history.push(LANDING_PAGE_URL)}>
            <BackIcon />
            {GetTypographyContent({
              content: "Back to Dashboard",
              size: "medium",
              textColor: "redMedium",
            })}
          </VideoPageBackTo>

          {GetTypographyContent({
            content: "Video Library",
            size: "h2",
            padding: `${deviceType === "mobile" ? "24px 0 0 20px" : ""}`,
            isBold: true,
          })}

          <VideoDescription>
            These videos provide general explanations for possible Unity results
            and common questions.
          </VideoDescription>

          {videoList.map((video) => (
            <VideoGeneralContainer
              key={video.name}
              data-testid={`video-library-card-${video.name}`}
            >
              <VideoLibraryCard
                name={video.name}
                url={video.url}
                image={video.image}
              />
            </VideoGeneralContainer>
          ))}
        </VideoPageComponentGrid>
      </VideoPageComponentWrapper>
    </VideoPageWrapper>
  );
};

export default VideoPage;
